import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../../service/udnick';
import { IFilter } from 'store/ducks/entregaNoCd/types';

export interface IEntregaNoCd {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface IEntregaNoCdResponse {
  pedidos: IEntregaNoCd;
  total: number;
}

interface CdInfo {
  centroDistribuicao: number;
  tempo: number;
}

export interface ITipoVeiculo {
  exigeAssoalho: boolean;
  codTip: number;
  nome: string;
  duracao: number;
  CDinfo: CdInfo[];
}

export interface ITipoVeiculoResponse {
  tiposVeiculos: ITipoVeiculo[];
  total: number;
}

export interface ITransportadora {
  codParceiro: number;
  nomeParceiro: string;
  cnpj: string;
  codCidade: number;
  cidade: string;
  uf: string;
  inscricaoEstadual: string;
}

export interface ITransportadoraResponse {
  transportadoras: ITransportadora[];
  total: number;
}

export const EntregaNoCdServices = {
  getAllData: (
    codCdd: number | undefined,
    filtro: IFilter | undefined,
    parceiros: number[] | undefined,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse<any>> =>
    UDNICK.callService(
      'getEntregas',
      {
        codCdd,
        filtro,
        parceiros,
      },
      { tamanhoPagina }
    ),

  getPedidosOrdemCarga: (
    ordemCarga: number,
    codEmp: number,
    parceiros: number[]
  ): Promise<AxiosResponse<IEntregaNoCdResponse>> =>
    UDNICK.callService('getPedidosOrdemCarga', {
      ordemCarga,
      codEmp,
      parceiros,
    }),
};

export const tiposVeiculosService = {
  getTiposCarroceria: (): Promise<AxiosResponse<ITipoVeiculoResponse>> =>
    UDNICK.callService('getTipoVeiculos', {}),
};

export const transportadoraService = {
  getTransportadoras: (
    codCdd: number,
    parceiros: number[]
  ): Promise<AxiosResponse<ITransportadoraResponse>> =>
    UDNICK.callService('getTransportadorasParceiras', { codCdd, parceiros }),
};
